import styled from "styled-components"
import {Col} from "react-bootstrap"

import {H4} from "@irati/ui/src/Typography"

export const BackArrowContainer = styled(Col)`
  margin-top: 13px;
`

export const StyledH4 = styled(H4)`
  max-width: 350px;
  margin: 0 auto;
`
export const IFrameWrapper = styled.div`
  width: 50%;
`

export const IFrame = styled.iframe`
  width: 100%;
  height: 100%;
`

export const TextWrapper = styled.div`
  max-width: 50%;
  margin-right: ${({theme}) => theme.spacing.two};
`
